(function () {
  "use strict";

  brandHeaderColor.$inject = ['$location', 'mtypes', 'accountInfoService'];
  angular
    .module('branding')
    .directive('brandHeaderColor', brandHeaderColor);

  function brandHeaderColor($location, mtypes, accountInfoService) {
    return {
      restrict: 'EA',
      templateUrl: 'pages/branding/template/headerColor.html',
      transclude: true,
      replace: true,
      require: ['ngModel', '^brandCrud'],
      scope: {},
      link: function (scope, element, attrs, ctrls) {
        if (!ctrls)
          return;

        var ngModel = ctrls[0];
        var crud = ctrls[1];

        scope.$watch(function () {
          return ngModel.$modelValue;
        }, function (modelValue) {
          if (scope.colorModel == modelValue)
            return;

          scope.colorModel = modelValue;
        });

        scope.$watch('colorModel', function (newValue, oldValue) {
          if (newValue === null || newValue === undefined)
            return;

          ngModel.$setViewValue(newValue);

          if (crud.resetting || angular.equals(newValue, oldValue))
            ngModel.$setPristine();
          else
            ngModel.$setDirty();

          crud.setDirty(ngModel.$dirty);
        }, true);

        scope.showFeatureUpgrade = function () {
          accountInfoService.openNewWindow();
        };
      }
    };
  }

})();
